import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as UserUtils from 'utils/user-utils';
import * as constants from '../constants/system-setup-constants';

import type {List, Map, MapOf} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type SsUsersSecurityStore = {
    settings: MapOf<{
        permissionGroups: List<Map<string, unknown>>;
        sharingDefaults: List<unknown>;
    }>;
    users: Map<unknown, unknown>;
    userGroups: Map<string, List<unknown>>;
};

const initialState = (): SsUsersSecurityStore => {
    return {
        settings: Immutable.Map({
            permissionGroups: Immutable.List<Map<string, unknown>>(),
            sharingDefaults: Immutable.List(),
        }),
        users: Immutable.Map(),
        userGroups: Immutable.Map(),
    };
};

const actionsMap: ActionsMap<SsUsersSecurityStore> = {
    [constants.SS_CENTER_SIGN_IN_PERMISSIONS_GROUPS_SUCCESS]: (state, action) => {
        return {
            settings: action.data,
        };
    },
    /**
     * Users lists are only used to populate components for searching/selecting
     * users to assign permissions overrides to. They do not need to persist
     * after a route change.
     */
    [constants.SS_PERMISSIONS_DISPOSE]: () => {
        return initialState();
    },
    /**
     * Multiple controls need to query for users based on different filters.
     * Distinguish between their query results using a key.
     */
    [constants.SS_USERS_SUCCESS]: (state, action) => {
        const key = action.key;
        const users = action.data;
        const sortedUsers = users.sortBy((user) => {
            return UserUtils.getLastNameFirst(user);
        });

        return {
            users: state.users.set(key, sortedUsers),
        };
    },
    /**
     * Multiple controls need to query for userGroups based on different filters.
     * Distinguish between their query results using a key.
     */
    [constants.SS_ROLES_SUCCESS]: (state, action) => {
        const key = action.key;
        const userGroups = action.data;
        const sortedRoles = userGroups.sortBy((ug) => ug.get('name'));

        return {
            userGroups: state.userGroups.set(key, sortedRoles),
        };
    },
};

export default createReducer<SsUsersSecurityStore>(initialState(), actionsMap);
